import PropTypes from 'prop-types';

import { FilterResourceByTag } from 'src/components/FilterResourceByTag';
import { FilterResourceByType } from 'src/components/FilterResourceByType';

import { MESSAGING_BANK_ASSET } from '../../utils';

import { useStyles } from './useStyles';

export const Filters = ({
  resourcesTypeFilter,
  resourcesTagFilter,
  onChangeResourcesTypeFilter,
  onChangeResourcesTagFilter,
  tags,
  shouldIncludeAudioVideoResources,
}) => {
  const styles = useStyles();

  return (
    <div className={styles.root}>
      <FilterResourceByType
        value={resourcesTypeFilter}
        onChange={onChangeResourcesTypeFilter}
        typeToAdd={MESSAGING_BANK_ASSET}
        shouldIncludeAudioVideoResources={shouldIncludeAudioVideoResources}
      />
      <FilterResourceByTag
        value={resourcesTagFilter}
        onChange={onChangeResourcesTagFilter}
        tags={tags}
      />
    </div>
  );
};

Filters.propTypes = {
  resourcesTypeFilter: PropTypes.arrayOf(PropTypes.string),
  onChangeResourcesTypeFilter: PropTypes.func.isRequired,
  resourcesTagFilter: PropTypes.arrayOf(PropTypes.string),
  onChangeResourcesTagFilter: PropTypes.func.isRequired,
  tags: PropTypes.arrayOf(PropTypes.string),
  shouldIncludeAudioVideoResources: PropTypes.bool,
};

Filters.defaultProps = {
  resourcesTypeFilter: [],
  resourcesTagFilter: [],
  tags: [],
  shouldIncludeAudioVideoResources: false,
};
